import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const finalLayout = useMemo(() => PrimaryLayout(), []);
    const handleSelectionChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    const handlePrimaryFormLoad = useCallback(() => {
        props.primaryFormLookupsLoad();
    }, [props.primaryFormLookupsLoad]);

    const showForm = props.hasFile || props.isEditMode;

    if (!showForm) {
        return null;
    }

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='c3d4e5f6-7a8b-9012-cdef-345678901234'
                layoutName='AIFileDataEntryPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
